import PropTypes from 'prop-types';
import React from 'react';
import SpendingSettingsSdkContainer from 'react/member/card/components/spending_monitor_tab/SpendingSettingsSdkContainer';
import SpendingMonitor from 'react/shared/card/components/spending_monitor_tab/SpendingMonitor';

export default function CardInInvestSpendingMonitorTabContainer({ accountId, canEdit, ruleSetId }) {
  const displaySdkView = $tlf.flipperEnableSpendingSettingsSdkToggle;

  return (
    <>
      {!displaySdkView && (
        <SpendingMonitor accountId={accountId} canEdit={canEdit} ruleSetId={ruleSetId} />
      )}
      {displaySdkView && <SpendingSettingsSdkContainer accountId={accountId} canEdit={canEdit} />}
    </>
  );
}

CardInInvestSpendingMonitorTabContainer.propTypes = {
  accountId: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired,
  ruleSetId: PropTypes.string,
};
